import TemplatesComponent from './Component';
import './Styles.scss';

const Templates = () => {
  return <TemplatesComponent />
}
export default Templates;           
